module.exports = ".Backgound{\r\n    background-color:#FBFEFF;\r\n}\r\n\r\n.FileSymbol{\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n}\r\n\r\n/* /deep/ .parametersPanel .mat-expansion-panel-body {\r\n    padding: 0;\r\n}\r\n\r\n.mat-expansion-panel-body {\r\n    padding: 0 0px 0px;\r\n} */\r\n\r\n:host ::ng-deep .mat-expansion-panel-body{\r\n    padding: 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/frustration/frustration.component.css
// module id = ./src/app/frustration/frustration.component.css
// module chunks = main